import { useMemo } from "react";
import { readFormDefinition } from "@froppio/form-core";
import { FormPreview } from "./FormPreview";
import { UnsupportedDefinition } from "./UnsupportedDefinition";

export function FormDefinitionView({ definition }: { definition: string }) {
  const result = useMemo(() => readFormDefinition(definition), [definition]);
  return result.success ? <FormPreview key={definition} draft={result.draft} />
    : <UnsupportedDefinition definition={definition} message={result.message} />;
}
